import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FaqService } from '../../../services/faq.service';

interface FAQ { id?: number; category: string; question: string; answer: string; keywords?: string; }

@Component({
  selector: 'app-faq-management',
  templateUrl: './faq-management.component.html',
  styleUrls: ['./faq-management.component.css']
})
export class FaqManagementComponent implements OnInit {
  @ViewChild('faqFormContainer') faqFormContainer!: ElementRef;
  faqs: FAQ[] = [];
  newFaq: FAQ = { category: '', question: '', answer: '', keywords: '' };
  editingId: number | null = null;
  formVisible: boolean = false;

  constructor(private faqService: FaqService) {}

  ngOnInit() { this.loadFaqs(); }

  loadFaqs() {
    this.faqService.getFaqs().subscribe(res => { this.faqs = res.faqs || res; });
  }

  addOrUpdate() {
    if (this.editingId) {
      this.faqService.updateFaq(this.editingId, this.newFaq).subscribe(() => { this.reset(); this.loadFaqs(); });
    } else {
      this.faqService.addFaq(this.newFaq).subscribe(() => { this.reset(); this.loadFaqs(); });
    }
  }

  edit(faq: FAQ) {
    this.newFaq = { ...faq };
    this.editingId = faq.id || null;
    this.formVisible = true; // Auto-open form when editing
    
    // Scroll to form after a brief delay to ensure it's rendered
    setTimeout(() => {
      if (this.faqFormContainer) {
        this.faqFormContainer.nativeElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
        // Focus on the first input field
        const firstInput = this.faqFormContainer.nativeElement.querySelector('input');
        if (firstInput) {
          firstInput.focus();
        }
      }
    }, 100);
  }

  toggleForm() {
    this.formVisible = !this.formVisible;
  }

  delete(id?: number) { if (!id) return; this.faqService.deleteFaq(id).subscribe(() => this.loadFaqs()); }

  reset() { this.newFaq = { category: '', question: '', answer: '', keywords: '' }; this.editingId = null; }
}
